import {Loader} from "@googlemaps/js-api-loader";
import apiFetch from "@wordpress/api-fetch";
import getCmp from '../helpers/cmpHelpers';


const themePath = wp_environment.theme_url;
const iconPath = themePath + '/assets/images/';
const blackIcon = iconPath + 'markerCaritas.svg';
const activeIcon = iconPath + 'marker.svg';
const lang = wp_environment.current_lang;
const cptRestPath = `/wp-json/wp/v2/csp_locations?per_page=-1&_fields[]=acf&_fields[]=csp_type_of_location&_fields[]=csp_place_not_in_map_view&_fields[]=title&_fields[]=id&lang=${lang}`;


const createMap = async (loader) => {
    // prevent google fonts from loading
    let head = document.getElementsByTagName('head')[0];

    // Save the original method
    let insertBefore = head.insertBefore;

    // Replace it!
    head.insertBefore = function (newElement, referenceElement) {

        if (newElement.href && newElement.href.indexOf('//fonts.googleapis.com/css') > -1) {

            // console.info('Prevented Roboto from loading!');
            return;
        }

        insertBefore.call(head, newElement, referenceElement);
    };
    let locations = [];
    let markersArray = [];
    await apiFetch({path: cptRestPath}).then(posts => {
        posts.map(p => {
            if (p.acf.csp_place_not_in_map_view === false) {
                locations.push(p);
            }
        })

    });
    let lastOpenedInfoWindow;


    loader.load().then(() => {
        const createMarkers = (obj, icon, styleClass) => {
            let addressClass = `csp-map-info ${styleClass}`;
            return obj.map(location => {
                if (location.acf.csp_place_not_in_map_view === false && location.acf.csp_place_address !== null) {
                    let title = location.acf.csp_place_address.name !== undefined ? location.acf.csp_place_address.name : location.title.rendered;
                    let marker = new google.maps.Marker({
                        map: map,
                        icon: icon,
                        draggable: false,
                        animation: google.maps.Animation.DROP,
                        position: {lat: location.acf.csp_place_address.lat, lng: location.acf.csp_place_address.lng},
                        dataLocationId: location.id
                    });
                    //Extend each marker's position in LatLngBounds object.

                    let contentString = `<address class="${addressClass}">` +
                        '<span class="font-weight-bold">' + location.title.rendered + '</span>' +
                        '<br>' +
                        location.acf.csp_place_address.street_name +
                        ' ' +
                        location.acf.csp_place_address.street_number +
                        '<br>' +
                        location.acf.csp_place_address.post_code +
                        ' ' +
                        location.acf.csp_place_address.city +
                        '<br>' +
                        'Website: ' +
                        location.acf.csp_place_website +
                        '</address>';
                    /*let infoWindow = new google.maps.InfoWindow({
                        content: contentString
                    })*/
                    marker.addListener('click', (ev) => {
                        markersArray.forEach(m => {
                            m.setIcon(icon);
                        })
                        let targetCard = document.getElementById(`${'map_card_' + marker.dataLocationId}`);
                        let targetParent = targetCard.closest?.('.suizidpraevention-tabs-map-pane-side-list');
                        let previousClone = targetParent.querySelector('.card-clone');
                        if (previousClone) {
                            previousClone.remove();
                        }
                        let currentlyActive = document.querySelector('.map-card-active.card-cloned');
                        let alreadyActive = false;

                        if (targetCard.classList.contains('map-card-active')) {
                            alreadyActive = true;
                        }


                        if (currentlyActive) {
                            currentlyActive.id = currentlyActive.id.replace('cloned', '');
                            currentlyActive.classList.remove('map-card-active');
                            currentlyActive.classList.remove('d-none');
                            currentlyActive.classList.add('suizidpraevention-location-card')
                        }
                        targetCard.classList.add('map-card-active');
                        if (!alreadyActive) {
                            marker.setIcon(activeIcon);
                            let clone = targetCard.cloneNode(true);
                            targetCard.id = targetCard.id.replace(targetCard.id, 'cloned' + targetCard.id);
                            targetCard.classList.add('card-cloned');
                            targetCard.classList.add('d-none');
                            targetCard.classList.remove('suizidpraevention-location-card')
                            clone.classList.add('card-clone');
                            let allCards = targetParent.querySelectorAll('.suizidpraevention-location-card');
                            targetParent.insertBefore(clone, allCards[0]);
                            targetParent.scrollTop = 0;
                            const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                            if(vw < 1181){
                                clone.scrollIntoView({
                                    behavior: "smooth",
                                    block: "center",
                                });
                            }

                        }


                    })
                    markersArray.push(marker);
                    return marker;
                }

            })
        }
        const fitMapBoundsToVisibleMarkers = (markers, map) => {
            let bounds = new google.maps.LatLngBounds(null);
            if (markers.length > 0) {
                for (let i = 0; i < markers.length; i++) {

                    bounds.extend(markers[i].getPosition());
                }
                map.setCenter(bounds.getCenter());
                map.fitBounds(bounds);

                google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
                    if (this.getZoom() > 13) {
                        this.setZoom(13);
                    }
                })
            }

        }

        const location = {lat: 52.520008, lng: 13.404954};
        const map = new google.maps.Map(document.getElementById('map'), {
            //zoom: 12,
            center: location,
            disableDefaultUI: false,
            styles: [
                {
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e1e1e1"
                        },
                        {
                            "lightness": 40
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#3d3c3c"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#4E4D4D"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#E9EAEA"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#4E4D4D"
                        }
                    ]
                },
                {
                    "featureType": "poi.attraction",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.attraction",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "saturation": -25
                        },
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.attraction",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "stylers": [
                        {
                            "saturation": -55
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#EAEAEA"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#4E4D4D"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"

                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#4E4D4D"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#FCBEBE"
                        },
                        {
                            "lightness": 45
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },

                {
                    "featureType": "road.local",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#4E4D4D"
                        }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#c6c6c6"
                        }
                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#c9c9c9"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#4E4D4D"
                        }
                    ]
                }
            ]
        });


        const clearMarkers = (markersArray) => {

            markersArray.forEach(m => {
                m.setMap(null);
            })
            return [];
        }

        createMarkers(locations, blackIcon, '');
        fitMapBoundsToVisibleMarkers(markersArray, map);
        document.addEventListener('filterChanged', async (ev) => {
            markersArray = clearMarkers(markersArray);
            let requestString = '';
            let toMark = [];
            //http://suizidpraevention.dev508.meap.local/wp-json/wp/v2/csp_locations?csp_help_for_group=19&csp_type_of_help=24,25&csp_type_of_offer=
            if (ev.detail.peer !== '') {
                requestString = `&csp_help_for_group=${ev.detail.peer.replaceAll('term_', '')}`;
            }
            if (ev.detail.helperType !== '') {

                requestString += `&csp_type_of_help=${ev.detail.helperType.replaceAll('term_', '')}`;

                /*  if (requestString === '') {
                      requestString += `?csp_type_of_help=${ev.detail.helperType.replaceAll('term_', '')}`;
                  }*/

            }
            if (ev.detail.offerType !== '') {

                requestString += `&csp_type_of_offer=${ev.detail.offerType.replaceAll('term_', '')}`;

                /* if (requestString === '') {
                     requestString += `?csp_type_of_offer=${ev.detail.offerType.replaceAll('term_', '')}`;
                 }*/
            }
            if (ev.detail.search !== '') {

                requestString += `&meta_key=csp_place_address&meta_value=${encodeURIComponent(ev.detail.search)}`;

                /* if (requestString === '') {
                     requestString += `?meta_key=csp_place_address&meta_value=${encodeURIComponent(ev.detail.search)}`;
                 }*/
            }

            let thePath = `/wp-json/wp/v2/csp_locations?per_page=-1${requestString}&_fields[]=acf&_fields[]=csp_type_of_location&_fields[]=title&_fields[]=id&lang=${lang}`
            if (requestString === '') {
                thePath = `/wp-json/wp/v2/csp_locations?per_page=-1&_fields[]=acf&_fields[]=csp_type_of_location&_fields[]=title&_fields[]=id&lang=${lang}`
            }
            await apiFetch({path: thePath}).then(posts => {
                posts.map(p => {
                    if (p.acf.csp_place_not_in_map_view === false) {
                        toMark.push(p);
                    }
                })
            });

            createMarkers(toMark, blackIcon, '');
            fitMapBoundsToVisibleMarkers(markersArray, map);
        })
    });
}
const runMap = () => {
    const placeholder = document.querySelector('.csp-map-tap-placeholder');
    const placeholderImage = placeholder.querySelector('.csp-map-tap-placeholder-image');
    const key = wp_environment.googleApiKey;
    const loader = new Loader({apiKey: key});
    let marker;
    const mapSectionInView = new Event('cspMapSection');
    if (document.getElementById('map')) {
        const theMapContainer = document.getElementById('map');
        const isDev = window.location.href.includes('meap.local') ? true : false;
        let x = getCmp();
        document.addEventListener('click', ev => {
            if (!ev.target.closest?.('.csp-map-tab-placeholder-button')) {
                return;
            }
            x('setVendorConsent', ['s1104', 1]);
            handlePlaceHolder(false);
        })
        const handlePlaceHolder = (activate = true) => {
            if (activate) {
                theMapContainer.classList.add('d-none');
                placeholder.classList.remove('d-none');
                placeholder.classList.add('d-flex');
                placeholderImage.setAttribute('src', placeholderImage.getAttribute('data-src'));
            }
            if (!activate) {
                theMapContainer.classList.remove('d-none');
                placeholder.classList.add('d-none');
                placeholder.classList.remove('d-flex');
                placeholderImage.setAttribute('src', '');
                createMap(loader);
            }
        }

        // polyfill if not supported
        if (!('IntersectionObserver' in window) ||
            !('IntersectionObserverEntry' in window) ||
            !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
            if (theMapContainer.getAttribute('data-consent-given') === 'given' || isDev) {
                document.dispatchEvent(mapSectionInView);
                if (x !== null) {
                    let consentData = x('getCMPData');
                    if ("s1104" in consentData.vendorConsents && consentData.vendorConsents["s1104"]) {
                        handlePlaceHolder(false);
                    } else {
                        handlePlaceHolder();
                    }
                }
            }
        } else {
            const mapContainer = document.querySelectorAll('.suizidpraevention-tabs-map-pane');
            const mapObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        document.dispatchEvent(mapSectionInView);
                        let x = getCmp();
                        if (x !== null) {
                            let consentData = x('getCMPData');
                            if ("s1104" in consentData.vendorConsents && consentData.vendorConsents["s1104"]) {
                                createMap(loader);
                                mapObserver.unobserve(entry.target);
                                handlePlaceHolder(false);

                            } else {
                                handlePlaceHolder();
                            }
                        }

                        mapObserver.unobserve(entry.target);
                    }
                });

            }, {rootMargin: '0px 0px 500px 0px'});
            setTimeout(
                () =>{
                    mapContainer.forEach(con => {
                        mapObserver.observe(con);
                    })
                }, 500
            );

        }
    }


}
export default runMap;
